import {
  OrderType,
  QBankStructureStatus,
  useSearchQBankStructuresLazyQuery,
} from '@exam-management/graphql';
import {
  type OptionSelectionProps,
  FormSearchSelection,
  Flex,
  SectionTitle,
} from '@shared/components';
import { useEffect, useMemo } from 'react';

import { EMPTY_LOCATION, EMPTY_QUESTION } from '../../constants/form-defaults';
import { useQuestionReviewTaskCreationFormContext } from '../../providers';

export default function TaskDetailSection() {
  const { watch, setValue } = useQuestionReviewTaskCreationFormContext();
  const courseId = watch('courseId');

  const [searchQBS, { data: searchQBSResult, loading: isSearchQBSLoading }] =
    useSearchQBankStructuresLazyQuery({
      variables: {
        search: {
          status: [QBankStructureStatus.Published, QBankStructureStatus.Unpublished],
        },
        paging: {
          currentPage: 0,
          pageSize: 200,
        },
        order: {
          field: 'name',
          type: OrderType.Asc,
        },
      },
    });

  useEffect(() => {
    setValue('location', EMPTY_LOCATION);
    setValue('question', EMPTY_QUESTION);
  }, [courseId, setValue]);

  const qbsOptions = useMemo<OptionSelectionProps[]>(
    () =>
      (searchQBSResult?.qbsSearchQBankStructures.qBankStructures ?? []).map((qbs) => ({
        label: `${qbs.code}: ${qbs.name}`,
        value: qbs.id,
      })),
    [searchQBSResult],
  );

  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        gap: theme.spacing(4),
      })}
    >
      <SectionTitle title='1. เลือกคลังข้อสอบ' />
      <FormSearchSelection
        name='courseId'
        label='เลือกคลังข้อสอบ'
        placeholder='เลือกคลังข้อสอบ'
        required
        fullWidth
        options={qbsOptions}
        loading={isSearchQBSLoading}
        onOpen={() => {
          searchQBS();
        }}
      />
    </Flex>
  );
}
